import React from 'react';
import styled from 'styled-components';
import useField from './hooks/use-field';
import getComponentByType from './helpers/get-component-by-type';
import getHandler from './helpers/get-handler';

const SearchOptions = ({
  type = 'select',
  forceType = false,
  selectionType = null,
  noSpacer,
  title, // f.e. Doesburg uses this, it doesnt use the Groups
  defaultOptionTitle,
  field,
  options,
  renameOptions = [],
  disabledWhenNoOptions,
  hideWhenNoOptions,
  multiSelect = false,
  className,
  handler = null,
  value = null,
  ...props
}) => {
  const {
    options: defaultOptions,
    value: defaultValue,
    handler: defaultHandler,
    arrayHandler,
  } = useField(field);

  const theOptions = renameOptions.length > 0 ? renameOptions.map((rename) => {
    // for example, rewrite true/false to Ja/Nee
    // also used to allowlist certain companies, others get dropped
    const option = (options || defaultOptions).find(({
      value: defaultOptionValue,
      name: defaultOptionName,
    }) => [defaultOptionValue, defaultOptionName].includes(rename.value || rename.name));
    if (!option) {
      return null;
    }
    return {
      ...option,
      value: option.value || option.name,
      name: rename.name,
    };
  }).filter(Boolean) : (options || defaultOptions);

  if (hideWhenNoOptions && theOptions.length === 0) {
    return null;
  }

  const Component = getComponentByType(type, forceType, selectionType);
  const theHandler = getHandler({
    handler,
    defaultHandler,
    arrayHandler,
    multiSelect,
  });

  return (
    <Options className={className}>
      {title && (
        <OptionTitle>{title}:</OptionTitle>
      )}
      <Component
        $noSpacer={noSpacer}
        name={field}
        currentValue={value || defaultValue}
        handler={theHandler}
        options={theOptions}
        defaultOptionTitle={defaultOptionTitle}
        disabledWhenNoOptions={disabledWhenNoOptions}
        {...props}
      />
    </Options>
  );
};

export const OptionTitle = styled.h3`
  font-size: 1rem;
  margin-bottom: .5rem;
  color: black;
`;

const Options = styled.div`
  font-weight: 500;
`;

export default styled(SearchOptions)``;
